function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import React from 'react';
import { createClassNames, translatable } from 'react-instantsearch-dom';
import GeoSearchContext from "./GeoSearchContext.js";
import withGoogleMaps from "./withGoogleMaps.js";
var cx = createClassNames('GeoSearch');
export var Control = function Control(_ref) {
  var googleMapsInstance = _ref.googleMapsInstance,
    translate = _ref.translate,
    isRefineOnMapMove = _ref.isRefineOnMapMove,
    hasMapMoveSinceLastRefine = _ref.hasMapMoveSinceLastRefine,
    toggleRefineOnMapMove = _ref.toggleRefineOnMapMove,
    refineWithInstance = _ref.refineWithInstance;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('control')
  }, isRefineOnMapMove || !hasMapMoveSinceLastRefine ? /*#__PURE__*/React.createElement("label", {
    className: cx('label')
  }, /*#__PURE__*/React.createElement("input", {
    className: cx('input'),
    type: "checkbox",
    checked: isRefineOnMapMove,
    onChange: toggleRefineOnMapMove
  }), translate('control')) : /*#__PURE__*/React.createElement("button", {
    className: cx('redo'),
    onClick: function onClick() {
      return refineWithInstance(googleMapsInstance);
    }
  }, translate('redo')));
};
var ControlWrapper = function ControlWrapper(props) {
  return /*#__PURE__*/React.createElement(GeoSearchContext.Consumer, null, function (_ref2) {
    var isRefineOnMapMove = _ref2.isRefineOnMapMove,
      hasMapMoveSinceLastRefine = _ref2.hasMapMoveSinceLastRefine,
      toggleRefineOnMapMove = _ref2.toggleRefineOnMapMove,
      refineWithInstance = _ref2.refineWithInstance;
    return /*#__PURE__*/React.createElement(Control, _extends({}, props, {
      isRefineOnMapMove: isRefineOnMapMove,
      hasMapMoveSinceLastRefine: hasMapMoveSinceLastRefine,
      toggleRefineOnMapMove: toggleRefineOnMapMove,
      refineWithInstance: refineWithInstance
    }));
  });
};
export default translatable({
  control: 'Search as I move the map',
  redo: 'Redo search here'
})(withGoogleMaps(ControlWrapper));